
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";
import { BlobResponse } from '../../Models/OtherClasses';

@Injectable()
export class TruckService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	) {
		this.url = urlService.getURL('Truck');
	}

	loadAllForMeAfterDate(): Observable<TooBig4Car.Logic.TruckUserAssignment[]> {
		return this.myBaseService.loadAll(this.url + '/MyForDate');
	}
	loadAssignmentsForTruckAndDate(id: System.Guid, date: Date): Observable<TooBig4Car.Logic.TruckUserAssignment[]> {
		var td = {
			TruckID: id,
			DateApplies: this.myBaseService.getDateStr(date)
		};
		return this.myBaseService.post(td, this.url + '/ForTruckAndDate', true);
	}
	saveAssign(obj: TooBig4Car.Logic.TruckUserAssignmentVM): Observable<string> {
		var dateFixed: any = Object.assign({}, obj);
		dateFixed.DateApplies = this.myBaseService.getDateStr(dateFixed.DateApplies);
		return this.myBaseService.post(dateFixed, this.url + '/Assign', false);
	}
	deleteAssignment(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url + '/Assign');
	}


	loadAll(activeOnly: boolean): Observable<TooBig4Car.Logic.Truck[]> {
		return this.myBaseService.loadAll(this.url + '?active=' + (activeOnly ?? true).toString());
	}
	save(tempItem: TooBig4Car.Logic.ObjectBase): Observable<TooBig4Car.Logic.Truck> {
		return this.myBaseService.save(tempItem, this.url);
	}
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
	getEdit(id: System.Guid): Observable<TooBig4Car.Logic.Truck> {
		return this.myBaseService.getEdit(id, this.url);
	}
	loadHistory(id: System.Guid): Observable<TooBig4Car.Logic.IHistoryDisplay[]> {
		return this.myBaseService.loadAll(this.url + '/History/' + (id ?? ''));
	}
	get(id: System.Guid): Observable<TooBig4Car.Logic.Truck> {
		return this.myBaseService.get(id, this.url);
	}
	search(searchTerm: string): Observable<TooBig4Car.Logic.Truck[]> {
		return this.myBaseService.post(searchTerm, this.url + '/Search', false);
	}
	getLabel(id: System.Guid): Observable<BlobResponse> {
		return this.myBaseService.loadBlob(this.url + '/' + (id || '') + '/Label');
	}
}

